import React from 'react';
import { Box } from '@mui/material';
import { FormSection } from '../../form/FormSection';
import { ResponsiveInput } from '../../form/ResponsiveInput';
import { FORM_SECTIONS } from '../../../config/formSections';
import { FORM_STYLES } from '../../../styles/formStyles';
import { FormValues } from '../CreateStep1V3';

interface ApartmentInfoSectionProps {
  values: FormValues;
  handleChange: (name: string) => (value: any) => void;
}

export const ApartmentInfoSection: React.FC<ApartmentInfoSectionProps> = ({
  values,
  handleChange
}) => {
  const sectionConfig = FORM_SECTIONS.apartmentInfo;

  return (
    <FormSection
      icon={sectionConfig.icon}
      iconColor={sectionConfig.color}
      title={sectionConfig.titleKey}
    >
      <Box sx={FORM_STYLES.layout.twoColumn}>
        <ResponsiveInput
          label="Bostadsyta"
          value={values.squareMeter}
          onChange={handleChange('squareMeter')}
          type="number"
          placeholder="75"
          unit="m²"
        />

        <ResponsiveInput
          label="Antal rum"
          value={values.rooms}
          onChange={handleChange('rooms')}
          type="number"
          placeholder="3"
        />
      </Box>
    </FormSection>
  );
}; 